import { type MonitoringHoursEvent } from './MonitoringHoursEvent.js';
import { type Patient } from './Patient.js';

export type MonitoringHoursRule = {
  id?: string;
  // `start` / `end` are the request shape only. The API stopped writing these columns at the
  // local-time migration, so they come back null on every rule created since.
  start?: string;
  end?: string;
  localStartTime?: string;
  localEndTime?: string;
  startDate?: string;
  durationMinutes?: number;
  patient?: Patient;
  patientId?: string;
  freq?: number;
  interval?: number;
  until?: string;
  byDay?: number[];
  repeats: boolean;
  events?: MonitoringHoursEvent[];
  type: MonitoringHoursType;
  checkInDuration?: number;
  checkInInterval?: number;
};

export enum MonitoringHoursType {
  MONITORING = 'MONITORING',
  CHECK_IN = 'CHECK_IN',
}
